import { Stack } from '@mui/material';
import { EventFormsSection } from './EventFormsSection';
import { WaiversSection } from './WaiversSection';
import useSettings from '../../hooks/useSettings';

interface ToDoTabProps {
  /**
   * Called whenever the remaining required forms count changes.
   * Use `null` to indicate "unknown" (e.g., load error) so callers
   * can hide badges instead of showing stale counts.
   */
  onCountChange?: (count: number | null) => void;
}

function ToDoTab({ onCountChange }: ToDoTabProps) {
  const { showEventWaivers, loading } = useSettings();

  return (
    <Stack spacing={3} sx={{ pt: 2 }}>
      <EventFormsSection onCountChange={onCountChange} />
      {!loading && showEventWaivers && <WaiversSection />}
    </Stack>
  );
}

export default ToDoTab;
